import { render, staticRenderFns } from "./StoragePanel.vue?vue&type=template&id=0c0d4205&"
import script from "./StoragePanel.vue?vue&type=script&lang=js&"
export * from "./StoragePanel.vue?vue&type=script&lang=js&"
import style0 from "./StoragePanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports